module.exports = __webpack_public_path__ + "img/cloud-bg4.57dd3eb0.png";